import { Navigate, Outlet } from "react-router-dom";
import PageContainer from "../../../components/common/PageContainer";
import { usePermission } from "../../../hooks/usePermissions";
import { Modules } from "../Roles/roles-utils";

const AccountsPage = () => {
  const hasPermission = usePermission(Modules.user.accessKey);

  if (!hasPermission) return <Navigate to="/home" />;

  return (
    <>
      <PageContainer title="User Management" subTitle="User" showDate>
        <Outlet />
      </PageContainer>
    </>
  );
};

export default AccountsPage;
